import { render, staticRenderFns } from "./FormValidationTypes.vue?vue&type=template&id=2cf0924b"
import script from "./FormValidationTypes.vue?vue&type=script&lang=js"
export * from "./FormValidationTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports